import React from "react";
import { useNavigate } from "react-router-dom";
import "./Careers.css";
import Crew1 from "./iSW Banner 1.png";
import Crew2 from "./iSW Banner 2.png";
import Crew3 from "./iSW Banner 3.png";
import Crew4 from "./iSW Banner 4.png";
const crewImages = [Crew1, Crew2, Crew3, Crew4];

function Careers() {
  const navigate = useNavigate();
  
  //Rotating crew image index and fade state
  const currentIndex = Math.floor(Math.random() * 4);

  const jobs = [
    {
      title: "iSpeakWell Specialist",
      description:
        "Lead users through appropriate app usage, assisting users to generate fluent, confident English speech. Training provided."
    },
        {
      title: "Social Media Marketing Specialist",
      description:
        "Creative communicator able to grow brand awareness and conversions through content."
    },
    {
      title: "Web Admin",
      description:
        "Responsible for IT support, testing, and platform quality control for smooth user experiences."
    },
    {
      title: "Applied Linguist",
      description:
        "Specializing in discourse analysis and adult education with experience in OpenAI and NLP."
    },
    {
      title: "Full Stack Web Developer",
      description:
        "Expertise in React, machine learning, OpenAI, server/backend, and database design."
    },
    {
      title: "Senior Software Engineer",
      description:
        "Deep skills in AI/ML, Python, NLTK, and OpenAI integration."
    }
  ];

  return (
    <div className="CRS-careers-container">
      <h1 className="CRS-Careers-header-title">The iSpeakWell Project</h1>
      <h5 className="CRS-tagline">
        Become a member of the iSpeakWell crew.
      </h5>
      <img
        src={crewImages[currentIndex]}
        alt="Overlay"
        style={{
          position: "relative",
          width: "55%",
          opacity: "0.80",
        }}
      />
      <h2 className="CRS-CareersHiring">Careers We're Hiring For:</h2>

      <div className="CRS-job-grid">
        {jobs.map((job, index) => (
          <div className="CRS-job-card" key={index}>
            <h3>{job.title}</h3>
            <p>{job.description}</p>
          </div>
        ))}
      </div>

      <p className="CRS-inquiries">
        Please email all career inquiries to{" "}
        <a href="mailto:info@ispeakwell.ca">info@ispeakwell.ca</a>
      </p>

      <div className="CRS-links-section">
        <button className="CRS-link-button" onClick={() => navigate("/about")}>About</button>
        <button className="CRS-link-button" onClick={() => navigate("/careers")}>Careers</button>
        <button className="CRS-link-button" onClick={() => navigate("/tokens")}>Tokens</button>
        <button className="CRS-link-button" onClick={() => navigate("/contactus")}>Contact Us</button>
        <button className="CRS-link-button" onClick={() => navigate("/login")}>Login</button>
      </div>
    </div>
  );
}

export default Careers;
